import { render, staticRenderFns } from "./SelectColumnCheck.vue?vue&type=template&id=9fef88ca&"
import script from "./SelectColumnCheck.vue?vue&type=script&lang=js&"
export * from "./SelectColumnCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports